"use strict";
exports.__esModule = true;
exports.ListItemText = exports.ListItemIcon = exports.MenuList = exports.MenuItem = exports.Menu = void 0;
var core_1 = require("@material-ui/core");
exports.Menu = core_1.Menu;
exports.MenuItem = core_1.MenuItem;
exports.MenuList = core_1.MenuList;
exports.ListItemIcon = core_1.ListItemIcon;
exports.ListItemText = core_1.ListItemText;
//# sourceMappingURL=Menu.js.map